import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";  // 페이지 이동을 위해 useNavigate 사용
import AdsNoticeList from "./components/AdsNoticeList";
import { useFixedLayout } from '../../hooks/useFixedLayout';
import { HeaderIconL } from '../../assets/components/HeaderGroup';
import left from "../../assets/icons/Arrow/left.svg"

const AdsNotice = () => {
    const [notices, setNotices] = useState(null);
    const navigate = useNavigate(); // useNavigate 훅 사용

    const location = useLocation();
    const type = location.state?.type ?? "";
    const storeBusinessNumber = location.state.storeBusinessNumber ?? "";
    const fromTab = location.state?.fromTab;
    const noticeFilter = location.state?.noticeFilter;
    const { headerRef, headerSpace } = useFixedLayout();


    // useEffect(() => {
    const fetchNotices = useCallback(async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice`);

            const list = response.data || [];

            const now = Date.now();
            const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

            const filtered = list.filter((n) => {
                const rawType = (n.notice_type || "").toString().trim();
                const type = rawType === "이벤트" ? "이벤트" : "일반";

                // 이벤트 공지는 최근 30일 이내만 노출
                if (type === "이벤트") {
                    const dateStr = n.created_at || n.notice_date;
                    if (!dateStr) return false;

                    const d = new Date(dateStr);
                    if (Number.isNaN(d.getTime())) return false;

                    const diff = now - d.getTime();
                    if (diff > THIRTY_DAYS_MS) {
                        return false; // 30일 초과 → 목록에서 제외
                    }
                }

                if (noticeFilter === "event") {
                    return type === "이벤트";
                }
                if (noticeFilter === "normal") {
                    return type === "일반";
                }
                return true; // (필터 안 들어온 경우: 전체)
            });
            setNotices(filtered); // filtered 사용
            // setNotices(response.data || []);
        } catch (error) {
            console.error("공지사항 불러오기 실패:", error);
        }
    }, [noticeFilter]);

    useEffect(() => {
        fetchNotices();
    }, [fetchNotices]);

    useEffect(() => {
        if (location.state?.noticeUpdated) {
            fetchNotices();  // ✅ 수정 시 재요청
        }
    }, [location.state?.noticeUpdated, fetchNotices]);



    // 🔄 뒤로 가기(홈)
    // const handleHome = () => {
    //     navigate("/ads/main", { state: { tab: "mypage" } });
    // }
    const handleClose = () => {
        if (fromTab === "mypage") {
            navigate("/ads/main", { state: { storeBusinessNumber: storeBusinessNumber, tab: "mypage" } });
        } else {
            navigate("/ads/alarm", { state: { storeBusinessNumber: storeBusinessNumber } }); // home에서 온 경우는 그냥 뒤로가기
        }
    };

    const headerTitle = noticeFilter === "event" ? "이벤트 알림" : "공지사항";

    return (
        <div className="mx-auto">
            <div ref={headerRef} className="fixed top-0 left-0 right-0 z-10">
                <HeaderIconL
                    className=""
                    title={headerTitle}
                    icon={left}
                    onIconClick={handleClose}
                />
            </div>

            {/* AdsNoticeList 컴포넌트 사용 */}
            <div className="px-[16px]" style={{ paddingTop: headerSpace }}>
                <AdsNoticeList
                    notices={notices}
                    isLoaded={notices !== null}
                    storeBusinessNumber={storeBusinessNumber}
                    type={type}
                    fromTab={fromTab}
                />
            </div>
        </div>
    );
};

export default AdsNotice;